import React, { MutableRefObject, RefObject, useEffect, useMemo, useRef, useState } from "react"
import { Col, Row } from "react-bootstrap"
import SkillActivityCardLoader from "@modules/Skill/components/SkillActivityCardLoader"
import SkillActivityItem from "./SkillActivityItem"
import { FindStudentManyActivityInput, StudentActivitiesQuery, useStudentActivitiesQuery } from "@generated/graphql"
import useIntersectionObserver from "@utils/useIntersectionObserver"

interface IActivityList {
  where: FindStudentManyActivityInput
}

export default function ActivityList({ where }: IActivityList) {
  const loadMoreRef = useRef<HTMLDivElement>(null)
  const [skip, setSkip] = useState(0)
  const take = 4
  const [activities, setActivities] = useState<StudentActivitiesQuery["studentActivities"]>([])
  const entry = useIntersectionObserver(loadMoreRef, {})

  const { data: activitiesData, loading: activitiesDataLoading, error: activitiesDataError } = useStudentActivitiesQuery({
    variables: {
      where: where,
      skip: skip,
      take: take
    },
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "cache-and-network"
  })

  useEffect(() => {
    if ((entry === undefined || entry?.isIntersecting === true) && (activities.length % 4 === 0)) {
      setSkip(activities.length)
    }
  }, [activities.length, entry])

  useEffect(() => {
    if (activitiesDataLoading === false && activitiesData && activitiesData?.studentActivities) {
      setActivities([...activities, ...activitiesData.studentActivities])
    }
  }, [activitiesDataLoading, skip])

  if (activitiesDataLoading && activities.length === 0) {
    return (<SkillActivityCardLoader count={8} />)
  }

  return <>
    {activities.length > 0 && activities.map((activity, index) =>
      <Col
        lg={{ span: 3, offset: 0 }}
        md={{ span: 3, offset: 0 }}
        sm={{ span: 4, offset: 0 }}
        xs={{ span: 10, offset: 1 }}
        key={index}
        className="p-4">
        <SkillActivityItem item={activity} />
      </Col>
    )}
    <span ref={loadMoreRef}></span>
  </>
}
